import * as tagColor from './CountTag.module.scss';

import { CountTag } from './CountTag';
import { isNumber } from '@sonar-software/sonar-ts-lib';
import { PercentageOutlined } from '@ant-design/icons';
import React from 'react';

export interface PopulationPercentageTagProps {
	parentName: string;
	percent?: number | null;
}

export const PopulationPercentageTag: React.FC<PopulationPercentageTagProps> = ({ parentName, percent }) =>
	<CountTag
		color={ tagColor.populationPercentage }
		count={ percent ?? undefined }
		icon={ <PercentageOutlined /> }
		tooltip={ `This field is populated on ${percent}% of ${parentName} records.` }
		visible={ isNumber(percent) } />;

